import { render } from "./homeworkDetail.vue?vue&type=template&id=7420d7f8&scoped=true"
import script from "./homeworkDetail.vue?vue&type=script&lang=js"
export * from "./homeworkDetail.vue?vue&type=script&lang=js"

import "./homeworkDetail.vue?vue&type=style&index=0&id=7420d7f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7420d7f8"]])

export default __exports__